<template>
  <el-dialog
    top="20vh"
    :visible.sync="showFilterDialog"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :width="modalWidth"
    :show-close="false"
    custom-class="custom-scrollable"
  >
    <div class="flex justify-between -mt-9 bg-white w-full">
      <span class="text-black-10 flex justify-center w-full text-base"
        >Select Currency / Country</span
      >
      <span class="cursor-pointer" @click="handleClose" test-id="closeIcon">
        <close-icon size="h-6 w-6" />
      </span>
    </div>

    <el-input
      placeholder="Type a Currency / Country"
      v-model="search"
      test-id="input"
    >
      <i slot="prefix" class="el-input__icon el-icon-search"> </i>
    </el-input>

    <div class="py-5 px-2">
      <span
        class="font-normal text-gray-muted cursor-pointer"
        @click="clearFilter"
      >
        See all Currencies
      </span>
    </div>

    <div class="flex flex-col gap-2" v-if="filteredCurrencies.length">
      <div
        class="flex justify-between cursor-pointer px-2 rounded-lg hover:bg-bg-muted py-3"
        :class="filterCurrency === item && 'bg-bg-muted'"
        v-for="(item, index) in filteredCurrencies"
        :key="index"
        @click="setFilter(item)"
        test-id="currencies"
      >
        <p class="flex gap-3 items-center">
          <currency-icon :currency="getCurrencyCountry(item)" size="h-6 w-6" />
          <span class="capitalize font-normal text-gray-muted"
            >{{ getCurrencyAndCountry(item) }}
            <span class="text-black-10 ml-1">({{ item }})</span>
          </span>
        </p>

        <span v-show="filterCurrency === item">
          <check-icon />
        </span>
      </div>
    </div>

    <div v-else class="flex justify-center">
      <empty-icon />
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { GetCurrencyCountry, GetCurrencyAndCountry } from '@/utils/helpers'
import { COUNTRIES } from '@/utils/constants'

export default {
  name: 'FilterRateDialog',
  props: {
    showFilterDialog: {
      type: Boolean,
      default: false
    },
    currencies: {
      type: Array,
      default: () => []
    }
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue'),
    CurrencyIcon: () => import('@/assets/icons/CurrencyIcons.vue'),
    EmptyIcon: () => import('@/assets/v2/icons/EmptyState2.vue'),
    CheckIcon: () => import('@/assets/v2/icons/CheckGoodIcon.vue')
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.mdAndDown
        ? '90%'
        : breakpoints.lgAndDown
        ? '50%'
        : '28%'
    },
    filteredCurrencies () {
      const uniqueCurrencies = new Set()
      this.currencies.forEach((item) => {
        uniqueCurrencies.add(item.from)
        uniqueCurrencies.add(item.to)
      })

      const countriesAndCurrency = COUNTRIES.filter((c) =>
        uniqueCurrencies.has(c.currency)
      )
      if (this.search !== '') {
        const filtered = countriesAndCurrency
          .filter(
            (item) =>
              item.currency.toLowerCase().includes(this.search.toLowerCase()) ||
              item.currencyFull
                .toLowerCase()
                .includes(this.search.toLowerCase())
          )
          .map((item) => item.currency)
        return filtered
      } else {
        return Array.from(uniqueCurrencies)
      }
    },
    filterCurrency () {
      return this.$store.state.common.filterCurrency
    }
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    getCurrencyAndCountry (val) {
      return GetCurrencyAndCountry(val)
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    setFilter (item) {
      this.$store.dispatch('common/setFilterCurrency', item)
      this.handleClose()
    },
    clearFilter () {
      this.$store.dispatch('common/setFilterCurrency', '')
      this.handleClose()
    }
  }
}
</script>

<style scoped>
>>> .el-input__inner {
  background: var(--input-background);
  color: var(--input-text);
  font-weight: 500;
  font-size: 14px;
  z-index: 0;
  border: 1px solid #e1e3f2 !important;
  border-radius: 8px;
}

>>> .el-input {
  margin-top: 24px;
  font-size: 16px;
}

>>> .el-input__icon .el-icon-search {
  height: 30px;
}
>>> .el-dialog {
  height: 470px !important;
  background-color: #ffffff;
}
</style>
